/** Legacy signup action types for temporary user redirect. */
export type TemporarySignupAction = 'import' | 'analyse';

export const TEMPORARY_SIGNUP_REDIRECT_PATH = '/account/portfoliosettings';

export const UPLOAD_TITBITS_MESSAGES = [
  'Processing your resume...',
  'Analyzing document structure...',
  'Extracting your experience...',
  'Optimizing for ATS compatibility...',
  'Almost there...',
] as const;

export const TERMS_BANNER_START = new Date('2025-11-01T00:00:00+05:30');
export const TERMS_BANNER_END = new Date('2025-11-30T23:59:59+05:30');

export const FB_PIXEL_ID = '467168176811795';
